// extracted by mini-css-extract-plugin
module.exports = {"currentOrderId":"CurrentOrderInfo_currentOrderId__1xwX8"};